module.exports = __webpack_public_path__ + "img/space.685bf414.png";